var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLink48Line = function SvgIconLink48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.49 14.6a6.257 6.257 0 0 1 4.45-1.85c1.68 0 3.27.66 4.49 1.88a6.301 6.301 0 0 1 0 8.91l-3.71 3.71 2.4 2.4 3.71-3.71c3.78-3.78 3.78-9.94-.04-13.75a9.645 9.645 0 0 0-6.86-2.84c-2.59 0-5.03 1.01-6.86 2.84l-3.71 3.71 2.4 2.4 3.71-3.71.02.01ZM23.47 33.51a6.301 6.301 0 0 1-8.91 0l-.03-.04a6.263 6.263 0 0 1-1.85-4.46c0-1.69.66-3.26 1.85-4.45l3.71-3.71-2.4-2.4-3.71 3.71a9.645 9.645 0 0 0-2.84 6.86c0 2.59 1.01 5.03 2.83 6.84l.03.04.02.02a9.685 9.685 0 0 0 6.86 2.84c2.48 0 4.97-.95 6.86-2.84l3.71-3.71-2.4-2.4-3.71 3.71-.02-.01Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.267 18.351-9.001 9.002 2.404 2.404 9.002-9.002-2.405-2.404Z",
    fill: "current"
  })));
};
export default SvgIconLink48Line;